import {ReactElement, useEffect, useState} from "react";
import Table, {SortParams} from "./Table";
import Pagination from "./Pagination";
import {Icon, Input, InputGroup, InputLeftElement} from "@chakra-ui/react";
import {SearchIcon} from "@chakra-ui/icons";

interface FetchFunction {
    page: number;
    perPage: number;
    searchTerm: string | undefined;
    sortParams: SortParams | null;
}

interface SearchTable {
    data: any;
    dataLength: number;
    columns: any[];
    onRowClick: (data: any) => void;
    fetchData: (data: FetchFunction) => void;
    page: number;
    setPage: (x: number) => void;
    perPage: number;
    setPerPage: (x: number) => void;
    search: string,
    setSearch: (x: string) => void;
    sortParams?: SortParams | null;
    setSortParams: (x: SortParams) => void;
    navigationOnTop?: boolean;
    additionFields?: ReactElement;
    disableMainSearch?: boolean;
}

const SearchTable = (props: SearchTable) => {
    const {
        data,
        dataLength,
        columns,
        page,
        perPage,
        search,
        onRowClick,
        fetchData,
        setPage,
        setPerPage,
        setSearch,
        sortParams,
        setSortParams,
        disableMainSearch
    } = props;

    const [loadingData, setLoadingData] = useState<boolean>(false);

    useEffect(() => {
        setLoadingData(true);
        console.log("Search")
        try {
            fetchData({
                page,
                perPage,
                searchTerm: search.length > 0 ? search : undefined,
                sortParams: sortParams ? sortParams : null,
            });
        } catch (e) {
            console.error(`ERROR FETCHING DATA: ${e}`);
        } finally {
            setLoadingData(false);
        }
    }, [page, perPage, search, sortParams]);

    return (
        <div className="flex items-center flex-col">
            <div className="w-full flex flex-col md:flex-row mx-6 my-2">
                <InputGroup size='md' className="mx-2">
                    <InputLeftElement pointerEvents='none'>
                        <Icon as={SearchIcon} className="m-2"/>
                    </InputLeftElement>
                    <Input
                        disabled={disableMainSearch}
                        pr='4.5rem'
                        type='text'
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder='Search'

                    />
                </InputGroup>
                {props.additionFields ?? <></>}
            </div>
            {
                props.navigationOnTop &&
                <div className="w-full">
                    <Pagination
                        dataLegth={dataLength}
                        page={page}
                        setPage={setPage}
                        perPage={perPage}
                        setPerPage={setPerPage}
                    />
                </div>
            }
            <div className="w-full">
                <Table
                    data={data}
                    columns={columns}
                    onRowClick={onRowClick}
                    Pagination={
                        !props.navigationOnTop ?
                            <Pagination
                                dataLegth={dataLength}
                                page={page}
                                setPage={setPage}
                                perPage={perPage}
                                setPerPage={setPerPage}
                            /> :
                            <></>
                    }
                    loading={loadingData}
                    sortParams={sortParams}
                    setSortParams={setSortParams}
                />
            </div>
        </div>
    )
}

export default SearchTable;